let state = {

    getfuncionarios:[],
    getprofessores:[],
    setFuncionario:'',

}

export default state